import * as React from 'react'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import IconButton from '@mui/material/IconButton'
import { useTheme } from '@mui/material/styles'

import { AdminUITheme } from 'types/AdminUiThemeMui'
import HtmlTooltip from 'components/Shared/Tooltip/HtmlStyledTooltip'

type Props = {
  info: any
  placement: any
} & typeof defaultProps

const defaultProps = {
  placement: 'bottom-start',
}

const TooltipComp = (props: Props) => {
  const { info, placement } = props
  const theme: AdminUITheme = useTheme()
  return (
    <HtmlTooltip title={info} placement={placement}>
      <IconButton
        aria-label="icon-btn"
        style={theme.ParticipantGrid?.toolTipIconButton}
        data-html2canvas-ignore="true"
      >
        <InfoOutlinedIcon fontSize="inherit" />
      </IconButton>
    </HtmlTooltip>
  )
}

TooltipComp.defaultProps = defaultProps

export default TooltipComp
